export default __webpack_public_path__ + "static/RUBICON-M-SERIES-28-ORBITAL-SCRUBBER-4c6601e0f330994f67f0edd353666c5e.png";